var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$config && _vm.$config.debug === "on"
    ? _c(
        "div",
        {
          staticClass: "debug-detail",
          class: _vm.debugIsOpen ? "" : "debug-info",
          on: {
            click: function ($event) {
              _vm.debugIsOpen = !_vm.debugIsOpen
            },
          },
        },
        [
          _c("br"),
          _vm._v(" "),
          _c("pre", [
            _vm._v("blackqueryResult: " + _vm._s(_vm.blackqueryResult)),
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c("pre", [_vm._v("debugInfo: " + _vm._s(_vm.debugInfo))]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c("pre", [_vm._v("shortVideo: " + _vm._s(_vm.shortVideo))]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c("pre", [
            _vm._v("originShortVideo: " + _vm._s(_vm.originShortVideo)),
          ]),
          _vm._v(" "),
          _c("br"),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }